<p-table #table [value]="loadedEntries" [lazy]="scIsLazy" (onLazyLoad)="loadRecords($event)" [paginator]="true"
  [totalRecords]="totalRecords" [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  [tableStyle]="{ 'min-width': '75rem' }" [selection]="selectedEntries" (selectionChange)="onSelectionChange($event)"
  (onEditComplete)="onEditComplete($event)" (selectAllChange)="onSelectAllChange($event)"
  [editMode]="'cell'" [rows]="scPageSize" [loading]="loading" [globalFilterFields]="globalFilterFields"
  [className]="scClass" [scrollable]="true" scrollHeight="calc(100vh - 200px)" [reorderableColumns]="scReorderColumns"
  [columns]="gridColumns" [ngClass]="{'toggleable-columns-grid': scToggleColumns}">

  <ng-template *ngIf="scToggleColumns" pTemplate="caption">
    <p-multiSelect display="chip" [options]="columnsOptions" [(ngModel)]="selectedColumns"
      (onChange)="onSelectedColumnsChanged()" optionLabel="title" selectedItemsLabel="{0} columns selected"
      placeholder="Choose Columns" />
  </ng-template>

  <ng-template pTemplate="header">
    <!-- column header row -->
    <tr>
      <th style="width: 4rem" *ngIf="scSelectionEnabled">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <ng-container *ngFor="let column of gridColumns">
        <th [pSortableColumn]="(column.type !== 8 && column.type !== 9 && !column.isNotSortable) ? column.field : ''"
          *ngIf="scReorderColumns; else noReorder" pReorderableColumn
          [pReorderableColumnDisabled]="!column.isReorderable">
          {{ column.title }}
          <p-sortIcon *ngIf="column.type !== 8 && column.type !== 9 && !column.isNotSortable"
            [field]="column.field"></p-sortIcon>
        </th>
        <ng-template #noReorder>
          <th [pSortableColumn]="(column.type !== 8 && column.type !== 9 && !column.isNotSortable) ? column.field : ''">
            {{ column.title }}
            <p-sortIcon *ngIf="column.type !== 8 && column.type !== 9 && !column.isNotSortable"
              [field]="column.field"></p-sortIcon>
          </th>
        </ng-template>
      </ng-container>
    </tr>

    <!-- select-all/filters row -->
    <tr>
      <th style="width: 4rem" *ngIf="scSelectionEnabled"></th>
      <th *ngFor="let column of gridColumns">
        <p-columnFilter [type]="'text'"
          *ngIf="scIsSearchable && column.type !== 8 && column.type !== 4 && column.type !== 9"
          [field]="column.field"></p-columnFilter>
      </th>
    </tr>
  </ng-template>

  <!-- data -->
  <ng-template pTemplate="body" let-record let-ri="rowIndex">
    <tr>
      <!-- selection checkbox -->
      <td *ngIf="scSelectionEnabled">
        <p-tableCheckbox [value]="record"></p-tableCheckbox>
      </td>

      <!-- data columns -->
      <td *ngFor="let column of gridColumns" [pEditableColumn]="record[column.field]" [pEditableColumnRowIndex]="ri"
        [ngSwitch]="typesMappings[column.type]" [pEditableColumnField]="column.field">

        <!-- text -->
        <div *ngSwitchCase="'text'">
          <p-cellEditor *ngIf="column.isEditable">
            <!-- edit -->
            <ng-template pTemplate="input">
              <text-editor [record]="record" [column]="column"></text-editor>
            </ng-template>
            <!-- display -->
            <ng-template pTemplate="output">
              <text-viewer [record]="record" [column]="column"></text-viewer>
            </ng-template>
          </p-cellEditor>
          <text-viewer *ngIf="!column.isEditable" [record]="record" [column]="column"></text-viewer>
        </div>

        <!-- number -->
        <div *ngSwitchCase="'numeric'">
          <p-cellEditor *ngIf="column.isEditable">
            <!-- edit -->
            <ng-template pTemplate="input">
              <number-editor [record]="record" [column]="column"></number-editor>
            </ng-template>
            <!-- display -->
            <ng-template pTemplate="output">
              <number-viewer [record]="record" [column]="column"></number-viewer>
            </ng-template>
          </p-cellEditor>
          <number-viewer *ngIf="!column.isEditable" [record]="record" [column]="column"></number-viewer>
        </div>

        <!-- combo -->
        <div *ngSwitchCase="'combo'">
          <p-cellEditor *ngIf="column.isEditable">
            <!-- edit -->
            <ng-template pTemplate="input">
              <dd-editor [record]="record" [column]="column"></dd-editor>
            </ng-template>
            <!-- display -->
            <ng-template pTemplate="output">
              <combo-viewer *ngIf="column.comboSettings?.data" [record]="record" [column]="column"></combo-viewer>
            </ng-template>
          </p-cellEditor>
          <div *ngIf="!column.isEditable">
            <combo-viewer *ngIf="column.comboSettings?.data" [record]="record" [column]="column"></combo-viewer>
          </div>
        </div>

        <!-- boolean -->
        <div *ngSwitchCase="'boolean'">
          <p-cellEditor *ngIf="column.isEditable">
            <!-- edit -->
            <ng-template pTemplate="input">
              <boolean-editor [record]="record" [column]="column"></boolean-editor>
            </ng-template>
            <!-- display -->
            <ng-template pTemplate="output">
              <boolean-viewer [record]="record" [column]="column"></boolean-viewer>
            </ng-template>
          </p-cellEditor>

          <div *ngIf="!column.isEditable">
            <boolean-viewer [record]="record" [column]="column"></boolean-viewer>
          </div>

        </div>

        <!-- date -->
        <div *ngSwitchCase="'date'">
          <p-cellEditor *ngIf="column.isEditable">
            <!-- edit -->
            <ng-template pTemplate="input">
              <date-editor [record]="record" [column]="column"></date-editor>
            </ng-template>
            <!-- display -->
            <ng-template pTemplate="output">
              <date-viewer [record]="record" [column]="column"></date-viewer>
            </ng-template>
          </p-cellEditor>

          <div *ngIf="!column.isEditable">
            <date-viewer [record]="record" [column]="column"></date-viewer>
          </div>
        </div>
        <!-- icon -->
        <div *ngSwitchCase="'icon'" class="icon-column {{ !!column.actionSettings ? 'clickable' : '' }}"
          (click)="onActionClick(column, record)">
          <img *ngIf="record[column.field]" src="{{record[column.field]}}" title="{{column.hover}}">
        </div>

        <!-- action -->
        <!-- display only -- no edit -->
        <button *ngSwitchCase="'action'" class="{{ column.cssClass ?? '' }}" (click)="onActionClick(column, record)">
          {{ column.actionSettings?.name != '' ? column.actionSettings?.name : record[column.field] }}
        </button>
      </td>

    </tr>
  </ng-template>
</p-table>
